import { useContext } from 'react'

import { SurveysContext } from '@/contexts/indications'

export const useSurveyExit = () => {
  const { handleExit } = useContext(SurveysContext)
  return { handleExit }
}
